module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/1-8645b90f57da10ab911d517b87fff24c.svg";